export default __webpack_public_path__ + "static/media/4484.5634e046.png";